import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { HttpCall, IHttpClient } from 'utils/http/httpClient.model';

import type { PersistedDashboard, PersistencePayload } from './model';
import { sanitizeRequest, sanitizeResult } from './sanitize';

export function persistDashboardConnector(http: IHttpClient) {
  return {
    persist(quotes: PersistencePayload): Observable<void> {
      return http
        .putRaw({
          url: 'api/v1/quotes/active',
          body: sanitizeRequest(quotes),
        })
        .pipe(map(() => void 0));
    },
    load(): Observable<PersistencePayload> {
      return http
        .getJSON<PersistedDashboard>({
          url: 'api/v1/quotes/active',
        })
        .pipe(map((r: HttpCall<PersistedDashboard>) => sanitizeResult(r.payload)));
    },
  };
}
